import { Injectable } from '@angular/core';
import { AppInitService } from 'src/app/app-init.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AppConfigurations } from 'src/app/shared/models/appConfiguration.model';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ApplicationModule } from '../models/application-modules.model';
import { Observable, of } from 'rxjs';
import { Language } from '../models/language.model';
import { ILocalizationRecord } from '../models/localization-record.model';
import { take } from 'rxjs/operators';
import { ILocalizationGridResponse } from '../models/localization-grid-response.dto';
import { ILocalizationGridRequestModel } from '../models/localization-grid-request.model';
import { IStaticLocalizedText } from '../models/static-localized-text.model';
import { ILocalizationUpdateRequest } from '../models/localization-update-request.model';
import { SortInfo } from 'src/app/shared/models/queryparams/sortinfo.model';
import { PageInfo } from 'src/app/shared/models/queryparams/pageinfo.model';
declare const window: any;

@Injectable({
  providedIn: 'root'
})


export class LocalizationService {
    private baseUrl: string = '';
    private localizationController: string = '';
    private lookupsController: string ='';
    private appConfig!: AppConfigurations;

    private recordToEdit: ILocalizationRecord | null = null;
    private currentlySelectedLanguage: Language | null = null;
    private selectedApplicationModules: ApplicationModule | null = null;
    private currentFilterTextValue: string | null = null;

    private sortInfo: SortInfo | null = null;
    private pageInfo: PageInfo | null = null;

  constructor(private appInitService: AppInitService, private http: HttpClient) {
    appInitService.getAppConfiguration$().subscribe({
      next: (config) => this._onReceievAppConfig(config)
    })
  }
  
  private _onReceievAppConfig(appConfig: AppConfigurations){
    this.appConfig = appConfig;
    this.baseUrl = this.appConfig.adminApi.baseApiUrl;
    this.lookupsController = this.appConfig.adminApi.lookupsController;
    this.localizationController = this.appConfig.adminApi.localizationController;
  }

  /*
  * Get application modules lookups
  */
  public getApplicationModules(): Observable<ApplicationModule[]> {
    const url = `${this.baseUrl}${this.lookupsController}/applicationmodules`;
    // const headersParams = new HttpHeaders().set('Authorization', pass);
    return this.http.get<ApplicationModule[]>(url);
  }


  /*
  * Get the language lookups
  */
  public getLanguages(): Observable<Language[]> {
    const url = `${this.baseUrl}${this.lookupsController}/languages`;
    // const headersParams = new HttpHeaders().set('Authorization', pass);
    return this.http.get<Language[]>(url);
  }

  /*
  * Get the localization data for grid
  */
  public getLocalizationGrid(requestModel: ILocalizationGridRequestModel): Observable<ILocalizationGridResponse> {
    const url = `${this.baseUrl}${this.localizationController}/language/${requestModel.languageId}`;
    // const headersParams = new HttpHeaders().set('Authorization', pass);
    let queryParams = new HttpParams();
    queryParams = requestModel.moduleIds ? queryParams.set('moduleList', requestModel.moduleIds.join('|')) : queryParams;
    queryParams = requestModel.filterText ? queryParams.set('searchText', requestModel.filterText) : queryParams;
    queryParams = requestModel.pageInfo ? queryParams
      .set('page', `${requestModel.pageInfo.Page}`)
      .set('pageSize', `${requestModel.pageInfo.PageSize}`) : queryParams;
    queryParams = requestModel.sortInfo ? queryParams
      .set('sortColumn', `${requestModel.sortInfo.SortColumn}`)
      .set('sortDirection', `${requestModel.sortInfo.sortDirection}`) : queryParams;

    return this.http.get<ILocalizationGridResponse>(url, {params: queryParams });
    // return this.getMockDataForGrid(moduleId);
  }

  /*
  *   Get all the localization records for a key
  */
  public getLocalizationsForKey(key: string, moduleId: number ): Observable<IStaticLocalizedText[]> {
    const url = `${this.baseUrl}${this.localizationController}/module/${moduleId}/${key}`;
    // const headersParams = new HttpHeaders().set('Authorization', pass);
    return this.http.get<IStaticLocalizedText[]>(url);
  }

  /*
  *   Update the localization records
  */
  public updateLocalizations(request: ILocalizationUpdateRequest) {
    const url = `${this.baseUrl}${this.localizationController}/module/${request.moduleId}/${request.key}`;
    // const headersParams = new HttpHeaders().set('Authorization', pass);
    return this.http.put<IStaticLocalizedText[]>(url, request.staticLocalizationText);
  }

  /*
  *   Get all available translations of a module for a given language.
  */
  public fetchTranslations(moduleId: number, languageId: number): Observable<object> {
    return this.http.get<object>(`${this.baseUrl}${this.localizationController}/module/${moduleId}/language/${languageId}`);
  }

  /*
  *   Set the record selected to be edited from the grid
  */
  public setLocalizationRecordToEdit(item: ILocalizationRecord) {
    this.recordToEdit = item;
  }
  /*
  *   Get the localization record selected to edit from the grid
  */
  public getLocalizationRecordToEdit(): ILocalizationRecord {
    if(this.recordToEdit == undefined || this.recordToEdit == null){
      throw Error("this.recordToEdit was undefined! Which was not expected!")
    } 
    return this.recordToEdit;
  }

  /*
  *   Set the application module selected in the grid view
  */
  public setSelectedApplication(application: ApplicationModule) {
    this.selectedApplicationModules = application;
  }

  /*
  *   Get the application module selected in the grid view
  */
  public getSelectedApplication() {
    return this.selectedApplicationModules;
  }

  /*
  *   Set the language selected in the grid view
  */
  public setCurrentlySelectedLanguage(lan: Language) {
    this.currentlySelectedLanguage = lan;
  }

  /*
  *   Get the language selected in the grid view
  */
  public getCurrentlySelectedLangauge() {
    return this.currentlySelectedLanguage;
  }

  /*
  *   Set the filter text of the searchfield in the grid view
  */
  public setCurrentFilterTextValue(val: string) {
    this.currentFilterTextValue = val;
  }

  /*
  *   Get the filter text of the searchfield in the grid view
  */
  public getCurrentFilterTextValue() {
    return this.currentFilterTextValue;
  }


  public setSortInfo(sortInfo: SortInfo) {
    this.sortInfo = sortInfo;
  }

  public getSortInfo(): SortInfo | null {
    return this.sortInfo;
  }

  public setPageInfo(pageInfo: PageInfo) {
    this.pageInfo = pageInfo;
  }

  public getPageInfo() {
    return this.pageInfo;
  }

  public resetData() {
    this.recordToEdit = null;
    this.currentlySelectedLanguage = null;
    this.selectedApplicationModules = null;
    this.currentFilterTextValue = null;

    this.sortInfo = null;
    this.pageInfo = null;
  }
}
